import { getEnv } from "../../helpers/env";
import { LANGUAGE_ACTIONS } from "../actions/actionTypes";

const initialState = {
    currentLanguage: getEnv("DEFAULT_LANGUAGE"),
};

export default function(state = initialState, action) {
  const { currentLanguage } = action.payload || {};
  switch (action.type) {
    case LANGUAGE_ACTIONS.CHANGE:
      return {
        ...state,
        currentLanguage
      };
    default:
      return state;
  }
}
